import { render, staticRenderFns } from "./SettingsFont.vue?vue&type=template&id=a180f516&scoped=true&"
import script from "./SettingsFont.vue?vue&type=script&lang=js&"
export * from "./SettingsFont.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFont.vue?vue&type=style&index=0&id=a180f516&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a180f516",
  null
  
)

export default component.exports